import React, { useState } from 'react';
import { AuthContext } from '../../store/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../../assets/css/custom-toast.css';
import { abreAlertaDialog } from '../modal/AlertaDialog';
import { AUTH_CONFIG } from '../../services/Api';
import MessageModal from '../modal/MessageModal';

const useFetch = (initialState) => {
  const [data, setData] = React.useState(initialState);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const { loginUser } = React.useContext(AuthContext);
  const navigate = useNavigate();
  const request = React.useCallback(async ({ url, options }) => {

    
    let response;
    let json;
    try {          
      setError(null);
      setLoading(true);
      response = await fetch(url, options);
      const text = await response.text();
      if (response.status === 403) {
        loginUser();
      }
      json = text ? JSON.parse(text) : null;
      if (response.ok === false) throw new Error(json?.msgs);
    } catch (err) {
      json = null;
      setError(err?.message || 'Ocorreu um erro inesperado');
      const urlErro =
        typeof response?.url === 'string'
          ? response.url
          : typeof url === 'string'
            ? url
            : '';
      const urlErroNormalizada = urlErro.toLowerCase();
      const isTokenIncorreto429 =
        response?.status === 429 &&
        (urlErroNormalizada.includes('/cadastro/senha-redefinicao') ||
          urlErroNormalizada.includes('/cadastro/reset-senha-redefinicao') ||
          urlErroNormalizada.includes('/cadastro/token/pf') ||
          urlErroNormalizada.includes('/cadastro/token/pj') ||
          urlErroNormalizada.includes('/cadastro/esqueci-senha-pf') ||
          urlErroNormalizada.includes('/cadastro/esqueci-senha-pj'));
      
      if (
        err.message.substring(0, 7) === 'MCN-014' ||
        err.message.substring(0, 7) === 'MCN-015' ||
        err.message.substring(0, 7) === 'MCN-016' ||
        err.message.substring(0, 7) === 'MCN-010' ||
        err.message.substring(0, 7) === 'MCN-022' ||
        err.message.substring(0, 7) === 'MCN-023' ||
        err.message.substring(0, 7) === 'MCN-029' ||
        err.message.substring(0, 7) === 'MCN-047' ||
        err.message.substring(0, 7) === 'MCN-048'
      ) {
        let campoComErro;
        let doc = 'CPF';
        switch (err.message.substring(0, 7)) {
          case 'MCN-014':
            campoComErro = 'Nome';
            break;
          case 'MCN-015':
            campoComErro = 'Nome da Mãe';
            break;
          case 'MCN-016':
            campoComErro = 'Data de Nascimento';
            break;
          case 'MCN-010':
            campoComErro = 'Bloqueado';
            break;
          case 'MCN-022':
            campoComErro = 'Razão Social';
            doc = 'CNPJ';
            break;
          case 'MCN-023':
            campoComErro = 'Nome fantasia';
            doc = 'CNPJ';
            break;
          case 'MCN-029':
            campoComErro = 'Bloqueado';
            doc = 'CNPJ';
            break;
          case 'MCN-047':
            campoComErro = 'cpf';
            doc = 'CPF';
            break;
          case 'MCN-048':
            campoComErro = 'cnpj';
            doc = 'CNPJ';
            break;
        }
        toast(
          ({ closeToast }) => (
            <div className="custom-toast">
              <img
                alt="imagem de perfil da carol, assistente virtual dos correios"
                id="img-carol-boasvindas"
                src="/images/carol-perfil.png"
              />
              <br />
              <p style={{ textAlign: 'justify' }}>
                {campoComErro != 'Bloqueado' ? (
                  /* <>
                    Caro Cliente, o dado informado no campo {campoComErro} está
                    divergente do dado informado na Receita Federal, favor
                    ajustar. Para consultar, acesse o link:
                  </>*/
                  <>{err.message.substring(8)}</>
                ) : (
                  <>
                    Caro Cliente, não foi possível realizar esta operação. Seu{' '}
                    {doc} foi temporariamente bloqueado para cadastro no Meu
                    Correios devido a uma divergência nos dados informados.
                    Confirme seus dados junto à Receita Federal e tente
                    novamente mais tarde. Para consultar, acesse o link:
                  </>
                )}

                <br />
                {doc === 'CNPJ' ? (
                  <>
                    <a
                      className="txt-link"
                      href="https://consultacnpj.redesim.gov.br/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      consultacnpj.redesim.gov.br/
                    </a>
                  </>
                ) : (
                  <>
                    <a
                      className="txt-link"
                      href="https://cav.receita.fazenda.gov.br/autenticacao/login"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      cav.receita.fazenda.gov.br/autenticacao/login
                    </a>
                  </>
                )}
              </p>
              {campoComErro != 'Bloqueado' ? (
                <button
                  onClick={() => {
                    closeToast();
                  }}
                >
                  OK
                </button>
              ) : (
                <button
                  onClick={() => {
                    closeToast();
                    navigate('/login');
                  }}
                >
                  OK
                </button>
              )}
            </div>
          ),
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: false, // Isso impede que o toast feche automaticamente
            closeOnClick: false, // Isso impede que o toast feche ao clicar
            closeButton: false,
          },
        );
      } else if(err.message.substring(0, 7) === 'MCN-057' ){  // CADASTRO
          toast(
              ({ closeToast }) => (
                <MessageModal
                    msgSuperior="Para cadastrar uma pessoa jurídica, o representante legal deve possuir cadastro de pessoa física ativo no Meu Correios."
                    msgInferior=""
                    textoDoLink="Acesse aqui e faça seu cadastro."
                    href="cadastroPF"
                    onClick={closeToast} />
              ),{
                position: toast.POSITION.TOP_CENTER,
                autoClose: false, // Isso impede que o toast feche automaticamente
                closeOnClick: false, // Isso impede que o toast feche ao clicar
                closeButton: false, // Remove o botão padrão de fechar
              },
          );
      } else if(err.message.substring(0, 7) === 'MCN-058' ){
        toast(
              ({ closeToast }) => (
                <MessageModal
                    msgSuperior="O CPF informado não foi localizado no cadastro do CNPJ nem nos registros dos Correios. Para prosseguir com o cadastro como representante legal da empresa, será necessário confirmar sua representação. Acesse aqui e faça seu cadastro:"
                    msgInferior="Envie uma cópia do contrato social (ou ata/portaria/ato constitutivo da entidade), procuração legal e RG."
                    textoDoLink="Fale conosco correios/cadastro."
                    href="https://faleconosco.correios.com.br/faleconosco/app/cadastro/suporte/tecnologico-mc/index.php"
                    onClick={closeToast} />
              ),{
                position: toast.POSITION.TOP_CENTER,
                autoClose: false, // Isso impede que o toast feche automaticamente
                closeOnClick: false, // Isso impede que o toast feche ao clicar
                closeButton: false, // Remove o botão padrão de fechar
              },
          );
      } else if(err.message.substring(0, 7) === 'MCN-061' ){ //RL expirado 
          toast(
              ({ closeToast }) => (
                <MessageModal
                    msgSuperior="O prazo de vigência do seu vínculo como Representante Legal expirou. Para prosseguir com o cadastro como representante legal da empresa, será necessário confirmar sua representação. Acesse aqui e faça seu cadastro:"                    
                    textoDoLink="Fale Conosco – Cadastro"
                    href="https://faleconosco.correios.com.br/faleconosco/app/cadastro/suporte/tecnologico-mc/index.php"
                    msgInferior="Envie uma cópia do contrato social, ou ata/portaria/ato constitutivo da entidade, ou procuração legal e RG."
                    onClick={closeToast}/>
              ),{
                position: toast.POSITION.TOP_CENTER,
                autoClose: false, // Isso impede que o toast feche automaticamente
                closeOnClick: false, // Isso impede que o toast feche ao clicar
                closeButton: false, // Remove o botão padrão de fechar
              },
          ); 
      } else if(err.message.substring(0, 7) === 'MCN-062' ){  // LOGIN     
          toast(
              ({ closeToast }) => (
                <MessageModal
                    msgSuperior="Para acessar o cadastro de pessoa jurídica, o representante legal deve possuir cadastro de pessoa física ativo no Meu Correios."
                    msgInferior=""
                    textoDoLink="Acesse aqui e faça seu cadastro."
                    href="cadastroPF"
                    onClick={closeToast}
                    abrirNovaJanela={true} />
              ),{
                position: toast.POSITION.TOP_CENTER,
                autoClose: false, // Isso impede que o toast feche automaticamente
                closeOnClick: false, // Isso impede que o toast feche ao clicar
                closeButton: false, // Remove o botão padrão de fechar
              },
          );
      } else if(err.message.substring(0, 7) === 'MCN-063' ){  //ESQUECI A SENHA PJ    
          toast(
              ({ closeToast }) => (
                <MessageModal
                    msgSuperior="Para recuperar o acesso da pessoa jurídica, o representante legal deve possuir cadastro de pessoa física ativo no Meu Correios."
                    msgInferior=""
                    textoDoLink="Acesse aqui e faça seu cadastro."
                    href="cadastroPF"
                    onClick={closeToast} />
              ),{
                position: toast.POSITION.TOP_CENTER,
                autoClose: false, // Isso impede que o toast feche automaticamente
                closeOnClick: false, // Isso impede que o toast feche ao clicar
                closeButton: false, // Remove o botão padrão de fechar
              },
          );
      } else if(err.message.substring(0, 7) === 'MCN-064' ){  //SITUAÇÃO CADASTRAL IRREGULAR JUNTO A RFB    
          toast(
              ({ closeToast }) => (
                <MessageModal
                    msgSuperior="Caro Cliente, não foi possível realizar seu cadastro devido a situação cadastral irregular junto à Receita Federal. Para consultar, acesse o link:"
                    msgInferior=""
                    textoDoLink="consultacnpj.redesim.gov.br/"
                    href="https://consultacnpj.redesim.gov.br/"
                    onClick={closeToast} />
              ),{
                position: toast.POSITION.TOP_CENTER,
                autoClose: false, // Isso impede que o toast feche automaticamente
                closeOnClick: false, // Isso impede que o toast feche ao clicar
                closeButton: false, // Remove o botão padrão de fechar
              },
          );
      } else if(err.message.substring(0, 7) === 'MCN-068' || isTokenIncorreto429 ){  //TOKEN - VÁRIAS TENTATIVAS ERRADAS
          toast(
              ({ closeToast }) => (
                <MessageModal
                    msgSuperior="Caro Cliente, seu acesso foi temporariamente bloqueado devido a sucessivas tentativas com erro. Tente novamente mais tarde."
                    msgInferior=""
                    textoDoLink=""
                    href=""
                    onClick={closeToast} />
              ),{
                position: toast.POSITION.TOP_CENTER,
                autoClose: false, // Isso impede que o toast feche automaticamente
                closeOnClick: false, // Isso impede que o toast feche ao clicar
                closeButton: false, // Remove o botão padrão de fechar
              },
          );      
      }else{
        // if (response.status === 404) {
        //   navigate('/login');
        // }
        const msg = err.message.trim();
        if (
          msg === 'Erro inesperado no processamento da API' ||
          msg.substring(0, 7) === 'CMN-004'
        ) {
          abreAlertaDialog(
            'Erro encontrado na aplicação. Tente em outro momento.',
          );
        } else if (err.message.substring(0, 7) === 'IDC-104') {
          navigate('/login');
        } else {
          if (
            err.message.substring(0, 3) == 'MCN' ||
            err.message.substring(0, 3) == 'IDC'
          ) {
            abreAlertaDialog(msg.substring(8));
          } else {
            abreAlertaDialog(msg);
          }
        }
        /*if (err.message.substring(0, 7) === 'MCN-034') {
          toast(
            ({ closeToast }) => (
              <div className="custom-toast">
                <img
                  alt="imagem de perfil da carol, assistente virtual dos correios"
                  id="img-carol-boasvindas"
                  src="/images/carol-perfil.png"
                />
                <br />
                <p style={{ textAlign: 'justify' }}>
                  {msg.substring(8)}
                  &nbsp; Para permissão de acesso é necessário realizar cadastro
                  no
                  <br />
                  <>
                    <a
                      className="txt-link"
                      href="/cadastroPF"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Meu Correios pessoa física
                    </a>
                  </>
                </p>
                <button
                  onClick={() => {
                    closeToast();
                  }}
                >
                  OK
                </button>
              </div>
            ),
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: false, // Isso impede que o toast feche automaticamente
              closeOnClick: false, // Isso impede que o toast feche ao clicar
              closeButton: false,
            },
          ); 
        } else { 
        */
        //  }
      }
    } finally {
      setData(json);
      setLoading(false);
      return { response, json };
    }
  }, []);

  const limpa = React.useCallback(() => {
    setData(initialState);
  }, [initialState]);
    
  return {
    data,
    loading,
    error,
    request,
    limpa,
  };
};

export default useFetch;
